exports.configuration = {

    environment: process.env.VUE_APP_NODE_ENV,

    sentry: {

        sentryUrl: 'https://6aac7e5c95ba41da88463ea990329581@o1110212.ingest.sentry.io/6138933'

    },

    url: {

        baseUrl: process.env.VUE_APP_BASE_URL,
        server: process.env.VUE_APP_SERVER_URL
    },

    front: {
        minimalAge: process.env.VUE_APP_MINIMAL_AGE,
        abTestingMaxDuration: process.env.VUE_APP_AB_TIMEOUT || 2000
    },

    email: {
        contact: 'support@cleanfox.io'
    },

    size: {
        tablet: 568,
        desktop: 800
    },

    tracking: {
        gtagId: process.env.VUE_APP_GTAG_ID,
        optimizeId: process.env.VUE_APP_OPTIMIZE_ID,
        amplitudeKey: process.env.VUE_APP_AMPLITUDE_KEY,
        smartBannerWebToken: process.env.VUE_APP_SMARTBANNER_WEB_TOKEN,
        adjustAppToken: process.env.VUE_APP_ADJUST_APP_TOKEN
    },

    languages: {
        all: [
            'en-GB',
            'fr-FR',
            'de-DE',
            'es-ES',
            'it-IT',
            'pt-PT',
            'pl-PL',
            'nl-NL',
            'nl-BE',
            'da-DK',
            'sv-SE'
        ],
        backwardLanguage: {
            'en': 'en-GB',
            'fr': 'fr-FR',
            'de': 'de-DE',
            'it': 'it-IT',
            'pl': 'pl-PL',
            'es': 'es-ES',
            'pt': 'pt-PT',
            'nl': 'nl-NL',
            'da': 'da-DK',
            'sv': 'sv-SE'
        },
        byName: {
            english: 'en',
            french: 'fr',
            german: 'de'
        }
    },

    defaultLanguage: 'en-GB',

    firebaseConfig: {
        apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGIN_SENDER_ID,
        appId: process.env.VUE_APP_FIREBASE_APP_ID,
        measurementId: process.env.VUE_APP_FIREBASE_MEASURMENT_ID,
        cloudMessagingCertificat: process.env.VUE_APP_CERTIFICATS_WEB_PUSH
    },

    indexedDb: {
        name: 'cleanfox',
        version: 1
    }
}
